// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c151bed8","404":"560d3db3","787":"938caa36"}[chunkId] + ".chunk.js";
};